// @flow

import * as React from 'react';
// import localize from '@ta/common.i18n';
import ObfuscatedLink from '@ta/common.obfuscated-link';
import { importScript } from '@ta/platform.import';
import styles from './Icp.less';

type Props = {
  icpUrl: string,
  recordFilingUrl: string,
  recordFilingIcon: string,
};

class IcpSection extends React.Component<Props> {
  componentDidMount() {
    importScript('//kxlogo.knet.cn/seallogo.dll?sn=e13021911010039226tprf000000&size=0', 'DD');
  }

  render() {
    const { icpUrl, recordFilingUrl, recordFilingIcon } = this.props;
    return (
      <div className={`is-hidden-mobile ${styles.icp} easyClear`}>
        <div className={styles.icp_text}>
          <ObfuscatedLink encodedUrl={icpUrl} target="_blank" useSpan>
            ICP证：沪B2-20200433
          </ObfuscatedLink>
          <ObfuscatedLink encodedUrl={icpUrl} target="_blank" useSpan>
            沪ICP备20013175号
          </ObfuscatedLink>
           <ObfuscatedLink encodedUrl={recordFilingUrl} target="_blank" useSpan>
            <img className={styles.record_filing_icon} src={recordFilingIcon} alt="" />
             沪公网安备31010502005427号
           </ObfuscatedLink>
          <span>鹰程信息技术（上海）有限公司</span>
        </div>
        <div id="kXScript" className="icp-logo" />
      </div>
    );
  }
}

export default IcpSection;
